var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1607 4.40743C12.4466 3.97747 11.5534 3.97747 10.8393 4.40743L10.323 4.71833C9.07029 5.47267 7.66391 5.93555 6.20803 6.07272L5.88275 6.10336C5.24066 6.16386 4.75 6.70292 4.75 7.34785V8.99174C4.75 11.7704 5.87808 14.4299 7.87584 16.3612L11.1312 19.5082C11.6157 19.9766 12.3843 19.9766 12.8688 19.5082L16.1242 16.3612C18.1219 14.4299 19.25 11.7704 19.25 8.99174V7.34785C19.25 6.70292 18.7593 6.16386 18.1172 6.10336L17.792 6.07272C16.3361 5.93555 14.9297 5.47266 13.677 4.71832L13.1607 4.40743Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShield);
export default __webpack_public_path__ + "static/media/ic_shield.2fd629a2276f1a8885dcb54eb4f013eb.svg";
export { ForwardRef as ReactComponent };